import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_exadnf3wpa: FaireBrandEntity = {
  token: "b_exadnf3wpa",
  type: "brand",
  name: "Natalie Clare Collections",
  avatarUrl:
    "https://cdn.faire.com/fastly/9491c25bea8c93645695a7b68aeeb1d89abf241e9cd8351fc2ba24f8d8075987.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b7b283a9ddcdfdd3031db29c64168402c4f3ca48ba7aa7f9e51407af04fe0dde.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9491c25bea8c93645695a7b68aeeb1d89abf241e9cd8351fc2ba24f8d8075987.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b7b283a9ddcdfdd3031db29c64168402c4f3ca48ba7aa7f9e51407af04fe0dde.jpeg",
  location: "Batavia , IL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "*Natalie Clare Collections does NOT allow rebranding of their products*\n\nNatalie Clare Collections is a woman owned business with handmade and specially curated jewelry located in Batavia, IL. The idea of Natalie Clare Collections began in 2016 when Natalie was working for a wholesale jewelry company and began designing her own pieces to be a part of that line known as “The Natalie Clare Collection”. Wanting to reach a different audience and have more freedom with her designs, Natalie started her own jewelry business in 2017 and it has been growing and evolving ever since. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:13.668Z",
    importedBy: "entity-db-cli",
  },
};
